var firebaseConfig = {
    apiKey: "AIzaSyAK43LcFRLOsyxpU-a0MKoFFjLbhhT_lUo",
    authDomain: "grab-vehicles.firebaseapp.com",
    projectId: "grab-vehicles",
    storageBucket: "grab-vehicles.appspot.com",
    messagingSenderId: "599048882740",
    appId: "1:599048882740:web:782f1c79643f438a11d861"
  };
export default firebaseConfig;